//@flow
import logStats from 'app/common/lib/logStats';

const SAMPLE_RATE = 1;
const METRIC_NAME_PREFIX = 'web.client_refresh';

export function logAutoClientRefreshDesktopEvent(
  eventType: 'refresh' | 'signal',
  eventName: string,
  context: Object,
  nextVersion: ?string,
  originHost: ?string,
) {
  logStats.increment(`${METRIC_NAME_PREFIX}.${eventType}.desktop`, SAMPLE_RATE, {
    stage: context.initialPageContext && context.initialPageContext.stage,
    currVersion: context.initialPageContext && context.initialPageContext.appVersion,
    nextVersion,
    pureReact: context.instance && context.instance.pure_react,
    isBot: context.instance && context.instance.is_bot,
    siteType: context.instance && context.instance.site_type,
    appType: context.instance && context.instance.app_type,
    event: eventName,
    originHost: originHost || 'unknown',
  });
}

export function logAutoClientRefreshMwebEvent(
  eventType: 'refresh' | 'signal',
  eventName: string,
  { stage, currVersion, nextVersion, isBot, originHost }: Object,
) {
  logStats.increment(`${METRIC_NAME_PREFIX}.${eventType}.mobile`, SAMPLE_RATE, {
    stage,
    currVersion,
    nextVersion,
    isBot,
    siteType: PCONST.thrift.SiteType.MOBILE,
    appType: PCONST.thrift.AppType.WEB_MOBILE,
    event: eventName,
    originHost: originHost || 'unknown',
  });
}
